import { personaStore } from 'entities/persona';
import { Layout } from 'widgets/layout';
import { PersonasList } from 'widgets/personas-list';
import { Loader } from 'shared/ui';
import { useEffect, useState } from 'react';
import { logger, useQueryParams } from 'shared/lib';
import { TavusPersonasList } from 'widgets/tavus-personas-list';
import { tavusPersonaStore } from 'entities/tavus/persona';
import { useAuthStore } from 'stores/useAuthStore';
import { creditStore } from 'entities/credit';
import {
  AVATARS_CREATE_PERSONA_ROUTE,
  CREATE_PERSONA_ROUTE,
  featureFlags
} from 'shared/model';
import { useNavigate } from 'react-router';
import { ConversationsTable } from 'widgets/conversations-table';
import { replicaStore } from 'entities/tavus/replica/model/replicaStore';

export const Dashboard = () => {
  const nav = useNavigate();
  const { isPersonasLoading, setCreateAgentModal } = personaStore((state) => ({
    isPersonasLoading: state.isPersonasLoading,
    setCreateAgentModal: state.setCreateAgentModal
  }));
  const { fetchReplicas } = replicaStore();
  const { toggleInactivePlanModal, isInactivePlan } = creditStore();
  const { isChatAvailable, toggleFeatureBlockModal } = creditStore((state) => ({
    isChatAvailable: state.isChatAvailable,
    toggleFeatureBlockModal: state.toggleFeatureBlockModal,
    isInactivePlan: state.isInactivePlan,
    toggleInactivePlanModal: state.toggleInactivePlanModal
  }));

  const { isAuth, toggleCreateAccModal } = useAuthStore((state) => ({
    isAuth: state.isAuth,
    toggleCreateAccModal: state.toggleCreateAccModal
  }));

  const tabs = [
    ...(featureFlags.tAvatars ? ['Avatars'] : []),
    ...(featureFlags.talkingPhotos ? ['Talking Photos'] : [])
  ];
  const handleCreateAgent = () => {
    if (!isAuth) return toggleCreateAccModal();
    if (!isChatAvailable) return toggleFeatureBlockModal('agents');
    if (isInactivePlan) return toggleInactivePlanModal();
    if (featureFlags.talkingPhotos) {
      return featureFlags.tAvatars
        ? setCreateAgentModal(true)
        : nav(CREATE_PERSONA_ROUTE);
    }

    return featureFlags.tAvatars ? nav(AVATARS_CREATE_PERSONA_ROUTE) : null;
  };

  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const params = useQueryParams();

  const { tavusPersonasLoading, fetchPersonas } = tavusPersonaStore(
    (state) => ({
      fetchPersonas: state.fetchPersonas,
      tavusPersonasLoading: state.tavusPersonasLoading
    })
  );

  useEffect(() => {
    if (featureFlags.tAvatars) {
      fetchPersonas();
      fetchReplicas();
    }
  }, []);

  const [showSurvey, setShowSurvey] = useState<
    'posthog-agents-call' | 'posthog-agents-create' | boolean
  >(false);

  useEffect(() => {
    if (params.get('posthog-agents-call') === 'true')
      setShowSurvey('posthog-agents-call');

    if (params.get('posthog-agents-create') === 'true')
      setShowSurvey('posthog-agents-create');
  }, []);

  useEffect(() => {
    logger.debug('posthog survey is triggered', showSurvey);
  }, [showSurvey]);

  return (
    <Layout>
      {typeof showSurvey === 'string' && (
        <div id={showSurvey} className="absolute size-0"></div>
      )}
      {isPersonasLoading || tavusPersonasLoading ? (
        <div className="ag-w-full ag-h-screen ag-flex ag-items-center ag-justify-center">
          <Loader size={96} />
        </div>
      ) : (
        <div className={'ag-w-full'}>
          <div className={'ag-flex ag-flex-col ag-w-full'}>
            {currentTab === 'Avatars' && (
              <TavusPersonasList
                ConversationsTableComponent={ConversationsTable}
              />
            )}
            {currentTab === 'Talking Photos' && <PersonasList />}
          </div>
        </div>
      )}
    </Layout>
  );
};
